import viewActionTypes from '../../view/constants/action-types';
import siteActionTypes from '../../site/constants/action-types';

export default [
  viewActionTypes.CHANGE_HTML,
  viewActionTypes.FORCE_RELOAD_VIEW,
  siteActionTypes.SET_ACTIVE_PAGE,
];
